<template>
	<div class="chat-box" @click="closeRefBox()" @mousemove="readedMessage()">
		<el-container>
			<el-header height="50px"
				style="text-align: left; border-bottom: 1px solid #D9DCE0;line-height: 50px;font-weight: 600;font-size: 16px;">
				<span>{{ title }} ({{ userInfo.orgName || '加载中...' }})</span>
				<span title="群聊信息" v-show="isGroup" class="btn-side el-icon-more" @click="showSide = !showSide"></span>
			</el-header>
			<el-main style="padding: 0; display: flex; width: 100%; height: 100%;">
				<div class="chat-layout">
					<el-container class="main-chat-container">
						<el-container class="content-box" style="border-right: 1px solid #D9DCE0;">
							<el-main class="im-chat-main" id="chatScrollBox" @scroll="onScroll">
								<div class="im-chat-box">
									<ul>
										<li v-for="(msgInfo, idx) in chat.messages" :key="idx">
											<chat-message-item v-if="idx >= showMinIdx" @call="onCall(msgInfo.type)"
												:mine="msgInfo.sendId == mine.id" :headImage="headImage(msgInfo)"
												:showName="showName(msgInfo)" :msgInfo="msgInfo"
												:groupMembers="groupMembers" @delete="deleteMessage"
												@recall="recallMessage">
											</chat-message-item>
										</li>
									</ul>
								</div>
							</el-main>
							<div v-if="!isInBottom" class="scroll-to-bottom" @click="scrollToBottom">
								{{ newMessageSize > 0 ? newMessageSize + '条新消息' : '回到底部' }}
							</div>
							<el-footer height="220px" class="im-chat-footer">
								<div class="chat-tool-bar">
									<div title="表情" ref="emotion" @click.stop="showEmotionBox()">
										<img src="@/assets/image/icon_smiley@2x.png" alt=""
											style="width: 16px;height: 16px;">
									</div>
									<div title="发送图片">
										<file-upload :action="'/image/upload'" :maxSize="5 * 1024 * 1024"
											:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
											@before="onImageBefore" @success="onImageSuccess" @fail="onImageFail">
											<img src="@/assets/image/icon_photos@2x.png" alt=""
												style="width: 16px;height: 16px;">
											<!-- <i class="el-icon-picture-outline"></i> -->
										</file-upload>
									</div>
									<div title="聊天记录" @click="showHistoryBox()">
										<img src="@/assets/image/icon_chat@2x.png" alt=""
											style="width: 16px;height: 16px;">
									</div>
								</div>
								<div class="send-content-area">
									<ChatInput :ownerId="group.ownerId" ref="chatInputEditor"
										:group-members="groupMembers" @submit="sendMessage" />
									<div class="send-btn-area">
										<!-- <el-button type="primary" 
											style="background-color: white;color: black; display: flex;align-items: center;justify-content: center;"
											@click="notifySend()">
											<img src="@/assets/image/icon_send.svg" alt="" style="width: 16px;height: 16px;">
											<span>发送</span>
										</el-button> -->
										<div style="width: 82px;height: 32px;border: 1px solid #D9DCE0;border-radius: 4px;display: flex;align-items: center;justify-content: center;cursor: pointer;"
											@click="notifySend()">
											<img src="@/assets/image/icon_send.svg" alt=""
												style="width: 16px;height: 16px;">
											<span style="font-size: 14px;margin-left: 2px;">发送</span>
										</div>
									</div>
								</div>
							</el-footer>
						</el-container>
						<el-aside class="side-box" width="320px" v-if="showSide">
							<chat-group-side :group="group" :groupMembers="groupMembers" @reload="loadGroup(group.id)">
							</chat-group-side>
						</el-aside>
					</el-container>
					<emotion ref="emoBox" @emotion="onEmotion"></Emotion>
					<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
					<group-member-selector ref="rtcSel" :group="group" @complete="onInviteOk"></group-member-selector>
					<rtc-group-join ref="rtcJoin" :groupId="group.id"></rtc-group-join>
					<chat-history :visible="showHistory" :chat="chat" :friend="friend" :group="group"
						:groupMembers="groupMembers" @close="closeHistoryBox"></chat-history>
				</div>
				<!-- 替换 right_query 区域为自定义滚动条结构 -->
				<div class="custom-scrollbar-container" @mouseenter="showScrollbar = true" @mouseleave="showScrollbar = false">
					<div
						class="custom-scrollbar-content"
						ref="scrollContent"
						@wheel="onWheel"
						@scroll="onContentScroll"
						style="width: 100%; height: 100%;"
					>
						<!-- 原 right_query-content 的内容 -->
						<div class="right_query-content" style="width: 100%;height:100%;padding-right: 0;">
							<div class="right_query-title"
								style="width: 100%;display: flex;justify-content: center;background-color: white;padding: 10px 0; border-bottom: 1px solid #E8EBF0 ;">
								正在咨询</div>
							<div v-if="isLoadingImMsgQuery && imMsgQuey.length === 0" class="loading-container">
								<div class="loading-spinner"></div>
								<div class="loading-text">加载中...</div>
							</div>
							<div v-else-if="!isLoadingImMsgQuery && imMsgQuey.length === 0" class="empty-container">
								<div class="empty-text">暂无咨询数据</div>
							</div>
							<div v-else>
								<div v-for="item in imMsgQuey" :key="item.busId">
									<div class="title"
										style="width: 100%;display: flex;justify-content: space-between;margin: 0 auto;background-color: white;padding: 10px 0; position: relative;">
										<div class="title-text"
											style="margin-left: 12px;text-align: left;width: 80%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;display: flex;align-items: center;margin-right: 12px;">
											<el-tag
												style="height: 24px;vertical-align: middle;line-height: 24px;padding: 0 8px;margin-right: 4px;"
												:color="item.labelColor + '10'" :style="{
													color: item.labelColor + 'FF',
													borderColor: item.labelColor + '50'
												}">
												{{ item.templateName }}
											</el-tag>
											<!-- busId 过长时超出隐藏需单独包裹span并设置样式 -->
											<span
												style="font-weight: 500; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block; vertical-align: middle;"
												:title="item.busId">
												{{ item.busId }}
											</span>
										</div>
										<!-- {{ item }} -->

										<div class="title-btn"
											style="width: 50px;height: 24px;background-color:rgba(2, 122, 255, 1);color:white;border-radius: 4px;cursor: pointer;font-size: 13px;display: flex;justify-content: center;margin-right: 20px;align-items: center;"
											@click="sendMsgQuery(item)">发送</div>
										<div
											style="width: 90%; height: 1px;background-color: #E8EBF0 ;margin-top: 10px;position: absolute;bottom: 0;left: 50%;transform: translateX(-51%);">
										</div>
									</div>
									<div
										style="width: 100%;display: flex;justify-content: center;border-bottom: 1px solid #E8EBF0 ;">
										<div
											style="width:100%; background-color: white;border-radius: 4px;box-shadow: inset;font-size: 14px;padding: 10px;line-height: 20px;max-width: 100%;overflow-x: auto;">
											<!-- {{ item }} -->
											<div v-for="(key, keyIndex) in toKeys(item.template)" :key="key"
												style="display: flex;margin: 8px 0;">
												<div
													style="width: 80px;text-align: right;margin-right: 5px;color: #9E9E9E;">
													{{ item.template[key] }}</div>
												:
												<span v-if="!isLast(item.template, keyIndex) && item.template[key] != '审核状态'"
													style="margin-left: 5px;width: 230px;max-width: 100%;overflow-x: auto;text-align: left;">
													{{ item.content[key] }}
												</span>
												<span v-if="isLast(item.template, keyIndex) && item.template[key] != '审核状态'"
													style="margin-left: 5px;display: flex;width: 230px;max-width: 100%;overflow-x: auto;text-align: left;">
													<div>{{ item.content[key] }}</div>
												</span>
												<span v-if="item.template[key] == '审核状态'"
													style="margin-left: 5px;display: flex;width: 230px;max-width: 100%;overflow-x: auto;text-align: left;">
													<div style="display: flex;align-items: center;">
														<img v-if="item.content[key] == '已提交'"
															src="@/assets/image/icon_ok@2x.png" alt=""
															style="width: 16px;height: 16px;margin-right: 2px;">
														{{ item.content[key] }}
													</div>
												</span>
											</div>
										</div>
									</div>

									<div style="width: 100%;background-color: #F0F0F1 ;height: 12px;"
									v-if="index !== imMsgQuey.length - 1"></div>
								</div>
								<!-- 设置最后一个的分割线不显示 -->
								
							</div>
						</div>
					</div>
					<div
						class="custom-scrollbar-bar"
						v-show="showScrollbar"
						:style="scrollbarStyle"
						@mousedown="onScrollbarMouseDown"
					></div>
				</div>
			</el-main>
			<emotion ref="emoBox" @emotion="onEmotion"></Emotion>
			<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
			<group-member-selector ref="rtcSel" :group="group" @complete="onInviteOk"></group-member-selector>
			<rtc-group-join ref="rtcJoin" :groupId="group.id"></rtc-group-join>
			<chat-history :visible="showHistory" :chat="chat" :friend="friend" :group="group"
				:groupMembers="groupMembers" @close="closeHistoryBox"></chat-history>
		</el-container>
	</div>
</template>

<script>
import ChatGroupSide from "./ChatGroupSide.vue";
import ChatMessageItem from "./ChatMessageItem.vue";
import FileUpload from "../common/FileUpload.vue";
import Emotion from "../common/Emotion.vue";
import ChatRecord from "./ChatRecord.vue";
import ChatHistory from "./ChatHistory.vue";
import ChatAtBox from "./ChatAtBox.vue"
import GroupMemberSelector from "../group/GroupMemberSelector.vue"
import RtcGroupJoin from "../rtc/RtcGroupJoin.vue"
import ChatInput from "./ChatInput";


export default {
	name: "chatPrivate",
	components: {
		ChatInput,
		ChatMessageItem,
		FileUpload,
		ChatGroupSide,
		Emotion,
		ChatRecord,
		ChatHistory,
		ChatAtBox,
		GroupMemberSelector,
		RtcGroupJoin
	},
	props: {
		chat: {
			type: Object
		}
	},
	data() {
		return {
			userInfo: {},
			group: {},
			groupMembers: [],
			sendImageUrl: "",
			sendImageFile: "",
			placeholder: "",
			isReceipt: true,
			showRecord: false, // 是否显示语音录制弹窗
			showSide: false, // 是否显示群聊信息栏
			showHistory: false, // 是否显示历史聊天记录
			lockMessage: false, // 是否锁定发送，
			showMinIdx: 0, // 下标低于showMinIdx的消息不显示，否则页面会很卡置
			reqQueue: [], // 等待发送的请求队列
			isSending: false, // 是否正在发消息
			isInBottom: false, // 滚动条是否在底部
			newMessageSize: 0, // 滚动条不在底部时新的消息数量
			imMsgQuey: [],
			// 新增缓存和状态管理
			imMsgQueryCache: new Map(), // 缓存查询结果
			isLoadingImMsgQuery: false, // 加载状态
			lastQueryKey: '', // 上次查询的key
			queryDebounceTimer: null, // 防抖定时器
			showScrollbar: false,
			scrollbarTop: 0,
			scrollbarHeight: 40,
			isDragging: false,
			dragStartY: 0,
			dragStartTop: 0,
		}
	},
	created() {
		// this.pullPrivateImMsgQuery()

	},
	methods: {

		sendMsgQuery(item) {
			console.log(item, "<<<<pushmsg", "11");
			let activeChat = this.$store.state.chatStore.activeChat;
			let item_cp = {};
			item_cp.content = JSON.stringify(item.content);
			item_cp.template = JSON.stringify(item.template);
			item_cp.templateKey = item.templateKey;
			item_cp.templateName = item.templateName;
			item_cp.labelColor = item.labelColor;
			item_cp.type = item.type;

			if (activeChat.type === "GROUP") {
				item_cp.groupId = activeChat.targetId;
			} else {
				item_cp.recvId = activeChat.targetId;
			}

			this.$http({
				url: "/immsgQuery/pushMsg",
				method: 'POST',
				data: item_cp
			}).then((e) => {
				console.log(e);
				// 发送成功后，清除相关缓存，下次会重新加载最新数据
				this.clearImMsgQueryCache(activeChat.targetId);
			}).catch((error) => {
				console.error('Failed to send message query:', error);
			})
		},
		isLast(template, index) {
			return index == Object.keys(template).length - 1 ? true : false;
		},
		toKeys(jsonObject) {
			return Object.keys(jsonObject);
		},
		pullImMsgQuery() {
			let activeChat = this.$store.state.chatStore.activeChat;
			console.log(activeChat, '<<<<<<<<<activeChat');
			if (activeChat && activeChat.targetId) {
				// 生成缓存key
				const cacheKey = `${activeChat.type}_${activeChat.targetId}`;

				// 如果正在加载相同的数据，直接返回
				if (this.isLoadingImMsgQuery && this.lastQueryKey === cacheKey) {
					return;
				}

				// 检查缓存
				if (this.imMsgQueryCache.has(cacheKey)) {
					this.imMsgQuey = this.imMsgQueryCache.get(cacheKey);
					this.lastQueryKey = cacheKey;
					return;
				}

				// 清除之前的防抖定时器
				if (this.queryDebounceTimer) {
					clearTimeout(this.queryDebounceTimer);
				}

				// 防抖处理，避免频繁请求
				this.queryDebounceTimer = setTimeout(() => {
					this._doPullImMsgQuery(cacheKey, activeChat);
				}, 100);
			}
		},

		_doPullImMsgQuery(cacheKey, activeChat) {
			// 设置加载状态
			this.isLoadingImMsgQuery = true;
			this.lastQueryKey = cacheKey;

			// 先显示缓存数据（如果有的话）
			if (this.imMsgQueryCache.has(cacheKey)) {
				this.imMsgQuey = this.imMsgQueryCache.get(cacheKey);
			} else {
				// 只有在没有缓存数据时才清空
				this.imMsgQuey = [];
			}

			let requestData = {};
			if (activeChat.type === "GROUP") {
				requestData.groupId = activeChat.targetId;
			} else {
				requestData.recvId = activeChat.targetId;
			}

			this.$http({
				url: "/immsgQuery/list",
				method: 'POST',
				data: requestData
			}).then((e) => {
				// 使用 try-catch 优化 JSON 解析
				try {
					e.forEach((item) => {
						if (typeof item.content === 'string') {
							item.content = JSON.parse(item.content);
						}
						if (typeof item.template === 'string') {
							item.template = JSON.parse(item.template);
						}
					});
				} catch (error) {
					console.error('JSON parse error:', error);
				}

				// 更新数据和缓存
				this.imMsgQuey = e;
				this.imMsgQueryCache.set(cacheKey, e);
				this.isLoadingImMsgQuery = false;
				console.log(this.imMsgQuey, '<<<<<<<<<this.imMsgQuey');
			}).catch((error) => {
				console.error('Failed to load imMsgQuery:', error);
				this.isLoadingImMsgQuery = false;
				// 如果请求失败，尝试显示缓存数据
				if (this.imMsgQueryCache.has(cacheKey)) {
					this.imMsgQuey = this.imMsgQueryCache.get(cacheKey);
				}
			});
		},
		moveChatToTop() {
			let chatIdx = this.$store.getters.findChatIdx(this.chat);
			this.$store.commit("moveTop", chatIdx);
		},
		closeRefBox() {
			this.$refs.emoBox.close();
			// this.$refs.atBox.close();
		},
		onCall(type) {
			if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VOICE) {
				this.showPrivateVideo('voice');
			} else if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO) {
				this.showPrivateVideo('video');
			}
		},
		onSwitchReceipt() {
			this.isReceipt = !this.isReceipt;
			this.refreshPlaceHolder();
		},
		onImageSuccess(data, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt;
			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.loadStatus = 'ok';
				msgInfo.id = m.id;
				this.isReceipt = false;
				this.$store.commit("insertMessage", [msgInfo, file.chat]);
			})
		},
		onImageFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.loadStatus = 'fail';
			this.$store.commit("insertMessage", [msgInfo, file.chat]);
		},
		onImageBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			let data = {
				originUrl: url,
				thumbUrl: url
			}
			let msgInfo = {
				id: 0,
				tmpId: this.generateId(),
				fileId: file.uid,
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: 1,
				readedCount: 0,
				loadStatus: "loading",
				status: this.$enums.MESSAGE_STATUS.UNSEND
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
			// 会话置顶
			this.moveChatToTop();
			// 滚动到底部
			this.scrollToBottom();
			// 借助file对象保存
			file.msgInfo = msgInfo;
			file.chat = this.chat;
		},
		onFileSuccess(url, file) {
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt
			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.loadStatus = 'ok';
				msgInfo.id = m.id;
				this.isReceipt = false;
				this.refreshPlaceHolder();
				this.$store.commit("insertMessage", [msgInfo, file.chat]);
			})
		},
		onFileFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.loadStatus = 'fail';
			this.$store.commit("insertMessage", [msgInfo, file.chat]);
		},
		onFileBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = {
				id: 0,
				tmpId: this.generateId(),
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: 2,
				loadStatus: "loading",
				readedCount: 0,
				status: this.$enums.MESSAGE_STATUS.UNSEND
			}

			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
			// 会话置顶
			this.moveChatToTop();
			// 滚动到底部
			this.scrollToBottom();
			// 借助file对象透传
			file.msgInfo = msgInfo;
			file.chat = this.chat;
		},
		onCloseSide() {
			this.showSide = false;
		},
		onScrollToTop() {
			// 多展示10条信息
			this.showMinIdx = this.showMinIdx > 10 ? this.showMinIdx - 10 : 0;
		},
		onScroll(e) {
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop
			if (scrollTop < 30) { // 在顶部,不滚动的情况
				// 多展示20条信息
				this.showMinIdx = this.showMinIdx > 20 ? this.showMinIdx - 20 : 0;
				this.isInBottom = false;
			}
			// 滚到底部
			if (scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 30) {
				this.isInBottom = true;
				this.newMessageSize = 0;
			}
		},
		showEmotionBox() {
			let width = this.$refs.emotion.offsetWidth;
			let left = this.$elm.fixLeft(this.$refs.emotion);
			let top = this.$elm.fixTop(this.$refs.emotion);
			this.$refs.emoBox.open({
				x: left + width / 2,
				y: top
			})
		},
		onEmotion(emoText) {
			this.$refs.chatInputEditor.insertEmoji(emoText);
		},
		showRecordBox() {
			this.showRecord = true;
		},
		closeRecordBox() {
			this.showRecord = false;
		},
		showPrivateVideo(mode) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}

			let rtcInfo = {
				mode: mode,
				isHost: true,
				friend: this.friend,
			}
			// 通过home.vue打开单人视频窗口
			this.$eventBus.$emit("openPrivateVideo", rtcInfo);
		},
		onGroupVideo() {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			// 邀请成员发起通话
			let ids = [this.mine.id];
			let maxChannel = this.$store.state.configStore.webrtc.maxChannel;
			this.$refs.rtcSel.open(maxChannel, ids, ids, []);
		},
		onInviteOk(members) {
			if (members.length < 2) {
				return;
			}
			let userInfos = [];
			members.forEach(m => {
				userInfos.push({
					id: m.userId,
					nickName: m.showNickName,
					headImage: m.headImage,
					isCamera: false,
					isMicroPhone: true
				})
			})
			let rtcInfo = {
				isHost: true,
				groupId: this.group.id,
				inviterId: this.mine.id,
				userInfos: userInfos
			}
			// 通过home.vue打开多人视频窗口
			this.$eventBus.$emit("openGroupVideo", rtcInfo);
		},
		showHistoryBox() {
			this.showHistory = true;
		},
		closeHistoryBox() {
			this.showHistory = false;
		},
		onSendRecord(data) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let msgInfo = {
				content: JSON.stringify(data),
				type: 3,
				receipt: this.isReceipt
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			this.sendMessageRequest(msgInfo).then((m) => {
				m.selfSend = true;
				this.$store.commit("insertMessage", [m, this.chat]);
				// 会话置顶
				this.moveChatToTop();
				// 保持输入框焦点
				this.$refs.chatInputEditor.focus();
				// 滚动到底部
				this.scrollToBottom();
				// 关闭录音窗口
				this.showRecord = false;
				this.isReceipt = false;
				this.refreshPlaceHolder();
			})
		},
		fillTargetId(msgInfo, targetId) {
			if (this.chat.type == "GROUP") {
				msgInfo.groupId = targetId;
			} else {
				msgInfo.recvId = targetId;
			}
		},
		notifySend() {
			this.$refs.chatInputEditor.submit();
		},
		async sendMessage(fullList) {
			this.resetEditor();
			this.readedMessage();
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let sendText = this.isReceipt ? "【回执消息】" : "";
			fullList.forEach(async msg => {
				switch (msg.type) {
					case "text":
						await this.sendTextMessage(sendText + msg.content, msg.atUserIds);
						break;
					case "image":
						await this.sendImageMessage(msg.content.file);
						break;
					case "file":
						await this.sendFileMessage(msg.content.file);
						break;
				}
			})
		},
		sendImageMessage(file) {
			return new Promise((resolve, reject) => {
				this.onImageBefore(file);
				let formData = new FormData()
				formData.append('file', file)
				this.$http.post("/image/upload", formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then((data) => {
					this.onImageSuccess(data, file);
					resolve();
				}).catch((res) => {
					this.onImageFail(res, file);
					reject();
				})
				this.$nextTick(() => this.$refs.chatInputEditor.focus());
				this.scrollToBottom();
			});
		},
		sendTextMessage(sendText, atUserIds) {
			return new Promise((resolve, reject) => {
				if (!sendText.trim()) {
					reject();
				}
				let msgInfo = {
					content: sendText,
					type: 0
				}
				// 填充对方id
				this.fillTargetId(msgInfo, this.chat.targetId);
				// 被@人员列表
				if (this.chat.type == "GROUP") {
					msgInfo.atUserIds = atUserIds;
					msgInfo.receipt = this.isReceipt;
				}
				this.lockMessage = true;
				this.sendMessageRequest(msgInfo).then((m) => {
					m.selfSend = true;
					this.$store.commit("insertMessage", [m, this.chat]);
					// 会话置顶
					this.moveChatToTop();
				}).finally(() => {
					// 解除锁定
					this.scrollToBottom();
					this.isReceipt = false;
					resolve();
				});
			});
		},
		sendFileMessage(file) {
			return new Promise((resolve, reject) => {
				let check = this.$refs.fileUpload.beforeUpload(file);
				if (check) {
					this.$refs.fileUpload.onFileUpload({ file });
				}
			})
		},
		deleteMessage(msgInfo) {
			this.$confirm('确认删除消息?', '删除消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$store.commit("deleteMessage", [msgInfo, this.chat]);
			});
		},
		recallMessage(msgInfo) {
			this.$confirm('确认撤回消息?', '撤回消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let url = `/message/${this.chat.type.toLowerCase()}/recall/${msgInfo.id}`
				this.$http({
					url: url,
					method: 'delete'
				}).then((m) => {
					this.$message.success("消息已撤回");
					m.selfSend = true;
					this.$store.commit("recallMessage", [m, this.chat]);
				})
			});
		},
		readedMessage() {
			if (this.chat.unreadCount == 0) {
				return;
			}
			this.$store.commit("resetUnreadCount", this.chat)
			if (this.chat.type == "GROUP") {
				var url = `/message/group/readed?groupId=${this.chat.targetId}`
			} else {
				url = `/message/private/readed?friendId=${this.chat.targetId}`
			}
			this.$http({
				url: url,
				method: 'put'
			}).then(() => { })
		},
		loadReaded(fId) {
			this.$http({
				url: `/message/private/maxReadedId?friendId=${fId}`,
				method: 'get'
			}).then((id) => {
				this.$store.commit("readedMessage", {
					friendId: fId,
					maxId: id
				});
			});
		},
		loadGroup(groupId) {
			this.$http({
				url: `/group/find/${groupId}`,
				method: 'get'
			}).then((group) => {
				this.group = group;
				this.$store.commit("updateChatFromGroup", group);
				this.$store.commit("updateGroup", group);
			});

			this.$http({
				url: `/group/members/${groupId}`,
				method: 'get'
			}).then((groupMembers) => {
				this.groupMembers = groupMembers;
			});
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.friend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				friend.showNickName = friend.remarkNickName ? friend.remarkNickName : friend.nickName;
				this.$store.commit("updateChatFromFriend", friend);
				this.$store.commit("updateFriend", friend);
			} else {
				this.$store.commit("updateChatFromUser", this.userInfo);
			}
		},
		loadFriend(friendId) {
			// 获取好友信息
			this.$http({
				url: `/user/find/${friendId}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		showName(msgInfo) {
			if (!msgInfo) {
				return ""
			}
			if (this.isGroup) {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.showNickName : msgInfo.sendNickName || "";
			} else {
				return msgInfo.selfSend ? this.mine.nickName : this.chat.showName
			}
		},
		headImage(msgInfo) {
			if (this.isGroup) {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.headImage : "";
			} else {
				return msgInfo.sendId == this.mine.id ? this.mine.headImageThumb : this.chat.headImage
			}
		},
		resetEditor() {
			this.$nextTick(() => {
				this.$refs.chatInputEditor.clear();
				this.$refs.chatInputEditor.focus();
			});
		},
		scrollToBottom() {
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				div.scrollTop = div.scrollHeight;
			});
		},
		refreshPlaceHolder() {
			if (this.isReceipt) {
				this.placeholder = "【回执消息】"
			} else if (this.$refs.editBox && this.$refs.editBox.innerHTML) {
				this.placeholder = ""
			} else {
				this.placeholder = "聊点什么吧~";
			}
		},
		sendMessageRequest(msgInfo) {
			return new Promise((resolve, reject) => {
				// 请求入队列，防止请求"后发先至"，导致消息错序
				this.reqQueue.push({ msgInfo, resolve, reject });
				this.processReqQueue();
			})
		},
		processReqQueue() {
			if (this.reqQueue.length && !this.isSending) {
				this.isSending = true;
				const reqData = this.reqQueue.shift();
				this.$http({
					url: this.messageAction,
					method: 'post',
					data: reqData.msgInfo
				}).then((res) => {
					reqData.resolve(res)
				}).catch((e) => {
					reqData.reject(e)
				}).finally(() => {
					this.isSending = false;
					// 发送下一条请求
					this.processReqQueue();
				})
			}
		},
		showBannedTip() {
			let msgInfo = {
				tmpId: this.generateId(),
				sendId: this.mine.id,
				sendTime: new Date().getTime(),
				type: this.$enums.MESSAGE_TYPE.TIP_TEXT
			}
			if (this.chat.type == "PRIVATE") {
				msgInfo.recvId = this.mine.id
				msgInfo.content = "该用户已被管理员封禁,原因:" + this.userInfo.reason
			} else {
				msgInfo.groupId = this.group.id;
				msgInfo.content = "本群聊已被管理员封禁,原因:" + this.group.reason
			}
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
		},
		generateId() {
			// 生成临时id
			return String(new Date().getTime()) + String(Math.floor(Math.random() * 1000));
		},

		// 清理指定聊天或所有聊天缓存
		clearImMsgQueryCache(targetId = null) {
			if (targetId) {
				// 清理指定聊天的缓存
				const groupKey = `GROUP_${targetId}`;
				const privateKey = `PRIVATE_${targetId}`;
				this.imMsgQueryCache.delete(groupKey);
				this.imMsgQueryCache.delete(privateKey);
			} else {
				// 清理所有缓存
				this.imMsgQueryCache.clear();
			}
		},

		// 更新缓存中的数据
		updateImMsgQueryCache(targetId, type, newData) {
			const cacheKey = `${type}_${targetId}`;
			this.imMsgQueryCache.set(cacheKey, newData);
		},
		updateScrollbar() {
			const content = this.$refs.scrollContent;
			if (!content) return;
			const ratio = content.clientHeight / content.scrollHeight;
			this.scrollbarHeight = Math.max(content.clientHeight * ratio, 30);
			this.scrollbarTop = content.scrollTop * ratio;
		},
		onContentScroll() {
			this.updateScrollbar();
		},
		onWheel(e) {
			this.$refs.scrollContent.scrollTop += e.deltaY;
			this.updateScrollbar();
		},
		onScrollbarMouseDown(e) {
			this.isDragging = true;
			this.dragStartY = e.clientY;
			this.dragStartTop = this.scrollbarTop;
			document.addEventListener('mousemove', this.onMouseMove);
			document.addEventListener('mouseup', this.onMouseUp);
		},
		onMouseMove(e) {
			if (!this.isDragging) return;
			const content = this.$refs.scrollContent;
			const delta = e.clientY - this.dragStartY;
			const ratio = content.scrollHeight / content.clientHeight;
			content.scrollTop = (this.dragStartTop + delta) * ratio;
			this.updateScrollbar();
		},
		onMouseUp() {
			this.isDragging = false;
			document.removeEventListener('mousemove', this.onMouseMove);
			document.removeEventListener('mouseup', this.onMouseUp);
		},
	},
	computed: {
		mine() {
			return this.$store.state.userStore.userInfo;
		},
		isFriend() {
			return this.$store.getters.isFriend(this.userInfo.id);
		},
		friend() {
			return this.$store.getters.findFriend(this.userInfo.id)
		},
		title() {
			let title = this.chat.showName;
			if (this.chat.type == "GROUP") {
				let size = this.groupMembers.filter(m => !m.quit).length;
				title += `(${size})`;
			}
			// 如果是个人在后面加上（公司名称）

			return title;
		},
		messageAction() {
			return `/message/${this.chat.type.toLowerCase()}/send`;
		},
		unreadCount() {
			return this.chat.unreadCount;
		},
		messageSize() {
			if (!this.chat || !this.chat.messages) {
				return 0;
			}
			return this.chat.messages.length;
		},
		isBanned() {
			return (this.chat.type == "PRIVATE" && this.userInfo.isBanned) ||
				(this.chat.type == "GROUP" && this.group.isBanned)
		},
		memberSize() {
			return this.groupMembers.filter(m => !m.quit).length;
		},
		isGroup() {
			return this.chat.type == 'GROUP';
		},
		isPrivate() {
			return this.chat.type == 'PRIVATE';
		},
		scrollbarStyle() {
			return {
				height: this.scrollbarHeight + 'px',
				top: this.scrollbarTop + 'px',
				opacity: this.showScrollbar ? 1 : 0,
			}
		},
	},
	watch: {
		chat: {
			handler(newChat, oldChat) {
				if (newChat.targetId > 0 && (!oldChat || newChat.type != oldChat.type ||
					newChat.targetId != oldChat.targetId)) {
					this.userInfo = {}
					this.group = {};
					this.groupMembers = [];
					if (this.chat.type == "GROUP") {
						this.loadGroup(this.chat.targetId);
						// 加载群聊消息查询数据
						this.pullImMsgQuery();
					} else {
						this.loadFriend(this.chat.targetId);
						// 加载已读状态
						this.loadReaded(this.chat.targetId)
						// 加载私聊消息查询数据
						this.pullImMsgQuery();
					}
					// 滚到底部
					this.scrollToBottom();
					this.showSide = false;
					// 消息已读
					this.readedMessage()
					// 初始状态只显示30条消息
					let size = this.chat.messages.length;
					this.showMinIdx = size > 30 ? size - 30 : 0;
					// 重置输入框
					this.resetEditor();
					// 复位回执消息
					this.isReceipt = false;
					// 更新placeholder
					this.refreshPlaceHolder();
				}
			},
			immediate: true
		},
		messageSize: {
			handler(newSize, oldSize) {
				if (newSize > oldSize) {
					if (this.isInBottom) {
						// 拉至底部
						this.scrollToBottom();
					} else {
						// 增加新消息提醒
						this.newMessageSize++;
					}
				}
			}
		}
	},
	mounted() {
		let div = document.getElementById("chatScrollBox");
		div.addEventListener('scroll', this.onScroll)
		// this.pullPrivateImMsgQuery()
		// let msgId = this.$route.query.msgId;
		// let chatData = this.$route.query.chatData;
		// console.log(msgId,chatData,'<<<<<<<<<msgId,chatData');
		this.$nextTick(() => {
			this.updateScrollbar();
		});
	},
	beforeDestroy() {
		// 清理定时器，避免内存泄漏
		if (this.queryDebounceTimer) {
			clearTimeout(this.queryDebounceTimer);
		}
		// 清理滚动事件监听器
		let div = document.getElementById("chatScrollBox");
		if (div) {
			div.removeEventListener('scroll', this.onScroll);
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-box {
	display: flex;
	width: 100%;
	height: 100%;
	min-width: 0;
}

.main-content {
	flex: 1;
	min-width: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.chat-header {
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 12px;
	font-size: var(--im-font-size-larger);
	border-bottom: var(--im-border);
	background: #fff;
	flex-shrink: 0;
}

.content-area {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	position: relative;
	height: 0;
}

.im-chat-main {
	flex: 1;
	min-width: 0;
	overflow-y: auto;
}

.right_query {
	width: 320px;
	min-width: 320px;
	max-width: 320px;
	flex: none;
	box-sizing: border-box;
	height: 100%;
	background: white;
	z-index: 1;
	padding-right: 0;
}

.right_query-content {
	padding: 0;
	min-width: 300px;
	box-sizing: border-box;
}

.loading-container,
.empty-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 40px 0;
	width: 100%;
	box-sizing: border-box;
}

.loading-spinner {
	width: 30px;
	height: 30px;
	border: 3px solid #f3f3f3;
	border-top: 3px solid #409eff;
	border-radius: 50%;
	animation: spin 1s linear infinite;
	margin-bottom: 10px;
}

.loading-text {
	color: #666;
	font-size: 14px;
}

.empty-text {
	color: #999;
	font-size: 14px;
}

.side-box {
	border-left: var(--im-border);
}

.content-box {
	position: relative;

	.im-chat-main {
		padding: 0;
		background-color: #fff;

		.im-chat-box {
			>ul {
				padding: 0;

				li {
					list-style-type: none;
				}
			}
		}
	}

	.scroll-to-bottom {
		text-align: right;
		position: absolute;
		right: 20px;
		bottom: 230px;
		color: #027aff;
		font-size: var(--im-font-size);
		// font-weight: 600;
		background: #ffffff;
		padding: 5px 15px;
		border-radius: 15px;
		cursor: pointer;
		z-index: 99;
		box-shadow: var(--im-box-shadow-light);
	}

	.im-chat-footer {
		display: flex;
		flex-direction: column;
		padding: 0;

		.chat-tool-bar {
			display: flex;
			position: relative;
			width: 100%;
			height: 36px;
			text-align: left;
			box-sizing: border-box;
			border-top: var(--im-border);
			padding: 4px 2px 2px 8px;

			>div {
				font-size: 22px;
				cursor: pointer;
				line-height: 30px;
				width: 30px;
				height: 30px;
				text-align: center;
				border-radius: 2px;
				margin-right: 8px;
				color: #999;
				transition: 0.3s;

				&.chat-tool-active {
					font-weight: 600;
					color: var(--im-color-primary);
					background-color: #ddd;
				}
			}

			>div:hover {
				color: #333;
			}
		}

		.send-content-area {
			position: relative;
			display: flex;
			flex-direction: column;
			height: 100%;
			background-color: white !important;

			.send-btn-area {
				padding: 11px;
				position: absolute;
				bottom: 4px;
				right: 6px;
			}
		}
	}
}

.main-chat-container {
	width: 596px;
	min-width: 596px;
	max-width: 100%;
	flex: none;
}

.chat-layout {
	display: flex;
	width: 100%;
	height: 100%;
}

.main-chat-container {
	flex: 1 1 0;
	min-width: 596px;
	max-width: 100%;
}

.right_query {
	width: 320px;
	min-width: 320px;
	max-width: 320px;
	flex: none;
}
.custom-scrollbar-container {
	position: relative;
	width: 320px !important;
	min-width: 320px !important;
	max-width: 320px !important;
	height: 100%;
	flex: none !important;
	box-sizing: border-box;
	background: #fff;
	overflow: hidden;
}
.custom-scrollbar-content {
	width: 100%;
	height: 100%;
	overflow-y: scroll;
	padding-right: 0;
	box-sizing: content-box;
	scrollbar-width: none;
}
.custom-scrollbar-content::-webkit-scrollbar {
	display: none;
}
.custom-scrollbar-bar {
	position: absolute;
	top: 0;
	right: 2px;
	width: 6px;
	background: rgba(0,0,0,0.2);
	border-radius: 3px;
	cursor: pointer;
	transition: opacity 0.2s;
	opacity: 1;
	z-index: 10;
}
/* 自定义 im-chat-main 滚动条样式 */
.im-chat-main::-webkit-scrollbar {
  width: 9px;
}
.im-chat-main::-webkit-scrollbar-thumb {
  background: #bfc2c7;
  border-radius: 4px;
}
.im-chat-main::-webkit-scrollbar-track {
  background: transparent;
}
/* 针对 Element UI 的 el-scrollbar 竖向滚动条 */
::v-deep .im-chat-main .el-scrollbar__bar.is-vertical {
  width: 9px !important;
  background: transparent !important;
  right: 2px;
}
::v-deep .im-chat-main .el-scrollbar__thumb {
  background: #bfc2c7 !important;
  border-radius: 4px !important;
}
</style>

<style lang="scss">
#chatScrollBox::-webkit-scrollbar {
  width:6px;
}
#chatScrollBox::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
#chatScrollBox::-webkit-scrollbar-track {
  background: transparent;
}

.im-chat-main::-webkit-scrollbar {
  width: 6px;
}
</style>